import React from "react";
import { usePFDataContext } from "../context/PfContext";
import { pdfURL } from "../variables";

const ProductListCta = () => {
    const { pfData } = usePFDataContext();


    // Function to handle printing the menu
    const handlePrintMenu = async (e) => {
        e.preventDefault();

        console.log(pdfURL );
        // Create a form to POST data
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = pdfURL;  // pdfURL points to your `generate-pdf.php` script
        
        // Add the data as a hidden form input
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'data';
        input.value = JSON.stringify(pfData.filteredpfProducts);
        form.appendChild(input);
        
        document.body.appendChild(form);
        form.submit();  // Submit the form to initiate the PDF generation and download
        form.remove();  // Cleanup after submission

    };






    return (
        <div className="pf__row flex__column">
            {/* Toggle Button */}
            <div id="ctas__nav-toggler" className="ctas__nav-toggler" role="button">
                <svg className="hamburger" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" aria-hidden="true">
                    <path d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32 32H416c17.7 0 32 14.3 32 32z"></path>
                </svg>

                <svg className="xmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" aria-hidden="true">
                    <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"></path>
                </svg>
            </div>

            {/* CTA Items */}
            <div className="ctas__nav-items flex flex__d-center flex__m-column flex__m-align-center">
                {/* Print Menu */}
                <div className="product__listing--print product__listing--cta flex__center">
                    <a href="#" 
                        data-action="petalfast-menu" 
                        onClick={ handlePrintMenu }
                    >
                        Print Menu
                    </a>
                </div>

                {/* Dynamically Render CTA Buttons */}
                { (
                    (pfData.pfButton1.url && pfData.pfButton1.text) ||
                    (pfData.pfButton2.url && pfData.pfButton2.text) ||
                    (pfData.pfButton3.url && pfData.pfButton3.text)

                ) && (
                    <div className="product__listing--cta flex__center">
                        {pfData.pfButton1.url && pfData.pfButton1.text && (
                            <a href={pfData.pfButton1.url} target="_blank" rel="noreferrer noopener">{pfData.pfButton1.text}</a>
                        )}
                        {pfData.pfButton2.url && pfData.pfButton2.text && (
                            <a href={pfData.pfButton2.url} target="_blank" rel="noreferrer noopener">{pfData.pfButton2.text}</a>
                        )}
                        {pfData.pfButton3.url && pfData.pfButton3.text && (
                            <a href={pfData.pfButton3.url} target="_blank" rel="noreferrer noopener">{pfData.pfButton3.text}</a>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ProductListCta;
